import { IUser, IUserDto } from '@app/interfaces/user.interface';
import { GenericModel } from '@app/models/generic.model';
import { TUser } from '@app/types/user.type';

export class UserModel extends GenericModel<IUser, IUserDto> implements IUser {
    email: string;
    firstName: string;
    id: string;
    lastName: string;
    role: TUser;
    countryAccess: string[];
    propertyAccess: string[];
    tool: boolean;
    elevEight: boolean;
    spectrio: boolean;
    lastLoginDate: string | null;

    error?: { type: 'ELEVEIGHT' | 'MEDUSA' | 'KONE'; message: string };
    isLoggedIn: boolean;
    redirectToLanding: boolean;

    constructor(data?: Partial<IUserDto>) {
        super(data, UserModel);

        this.email = data?.email ?? '';
        this.firstName = data?.firstName ?? '';
        this.id = data?.id ?? '';
        this.lastName = data?.lastName ?? '';
        this.role = data?.role ?? 'User';
        this.countryAccess = data?.countryAccess ?? [];
        this.propertyAccess = data?.propertyAccess ?? [];
        this.tool = data?.toolAccess ?? false;
        this.elevEight = data?.elevEightAccess ?? false;
        this.spectrio = data?.spectrioAccess ?? false;
        this.error = data?.error;
        this.lastLoginDate = data?.lastLoginDate ?? null;
    }

    get fullName(): string {
        return this.firstName + ' ' + this.lastName;
    }

    get hasRole(): boolean {
        return this.tool || this.elevEight || this.spectrio;
    }

    get singleAppAccess(): 'tool' | 'elevEight' | 'spectrio' | null {
        const roles = [
            this.tool && 'tool',
            this.elevEight && 'elevEight',
            this.spectrio && 'spectrio',
        ].filter(Boolean);

        return roles.length === 1 ? (roles[0] as 'tool' | 'elevEight' | 'spectrio') : null;
    }

    get originalRole(): TUser {
        return this.getOriginalData().role;
    }

    dataTransferObject(): Partial<IUserDto> {
        return {
            email: this.email,
            firstName: this.firstName,
            id: this.id,
            lastName: this.lastName,
            role: this.role,
            countryAccess: this.countryAccess,
            propertyAccess: this.propertyAccess,
            toolAccess: this.tool,
            elevEightAccess: this.elevEight,
            spectrioAccess: this.spectrio,
        };
    }
}
